<template>
        <section
          class="px-1"
        >
        <b-link :to="'/collection/'+item.id" class="no-underline text-decoration-none">
          <div class="d-flex text-center flex-column justify-content-center
               bg-white collection-carousel-item"
          >
            <i :class="['collection-icon', `i-${item.icon} ${portalGeneralInfo.Skin}`]"/>
          </div>
          <h6 class="text-center mt-2 subtext">
              {{ item.name }}
          </h6>
          </b-link>
        </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CollectionsCarouselItem',
  props:{
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl',
      portalConfigurations: 'tenantDesign/config'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    }
  }
}
</script>
